import React from "react";

import { Grid } from "@mui/material";
import { Constants as GridConstants } from "Components/AppGrid/shipeezi-new-grid";
import { useTranslation } from "react-i18next";
import { FiTrash2 } from "react-icons/fi";

import { CartonView } from "../../../../../../models/carton";
import { DefaultTooltip } from "../../../../Tooltip";
import useStyles from "../../../styles";

interface Props {
  carton?: CartonView;
  show?: boolean;

  deleteCarton: (sscc?: string) => void;
}

const DeleteButton = (props: Props) => {
  const { carton, show, deleteCarton } = props;
  const { t: translate } = useTranslation();

  const classes = useStyles();

  if (!deleteCarton || !show) return null;

  return (
    <Grid item data-cy="delete-sscc" className={classes.actionButton}>
      <DefaultTooltip title={translate("delete")}>
        <div onClick={() => deleteCarton(carton?.sscc)}>
          <FiTrash2 color="rgb(207, 42, 39)" size={GridConstants.defaultRowActionSize} />
        </div>
      </DefaultTooltip>
    </Grid>
  );
};

export default DeleteButton;
